import React, { useEffect, useState, useRef } from 'react'

// Importaciones Base (Asegúrate de que las rutas coincidan con tu proyecto)
import { GoalBase } from './../../Admin/Commons/GoalBase'
import { Picnic as PicnicDayGame } from './Picnic/Picnic' 
//import imgBrand from '../../../../assets/games/picnicDay/brand.png' 

// Importaciones de Negocio (El nuevo BL estandarizado)
import {
    ConnectPicnicWebSocket,
    SetPicnicSocketMessageHandler, 
    ClearPicnicSocketMessageHandler, 
    DisconnectPicnicWebSocket, 
    SendPicnicScoreProgress 
} from '../../../utilities/BL/Picnic'


/**
 * ==============================================================================
 * COMPONENTE HIJO: SELECCIÓN DE JUGADOR (Reutilizado de Goal)
 * ==============================================================================
 */
const SelectPicnicPlayer = ({ onPlayerPicked }) => {
    return (
        <GoalBase classNameApplied={'Fan__Goal__Header'}>
            <div className="Fan__Goal">
                <p className="Fan__Goal__Title text-shadow font-weight-bold">Día de Picnic</p>
                <p className="text-center mb-4">Selecciona tu personaje para jugar</p>

                <div className="Fan__Goal__Players">
                    <button className="Fan__Goal__Players__Buttons shadow" onClick={() => onPlayerPicked('lucho')}> 
                        <img src='/img/games/runtogoal/luchito-caricatura.png' alt="Lucho" className='Fan__Goal__Players__Buttons__Image' />
                        <span className='Fan__Goal__Players__Buttons__Text'>Lucho</span>
                    </button>
                    
                    <button className="Fan__Goal__Players__Buttons shadow" onClick={() => onPlayerPicked('tunita')}> 
                        <img src='/img/games/runtogoal/tunita-caricatura.png' alt="Tunita" className='Fan__Goal__Players__Buttons__Image' />
                        <span className='Fan__Goal__Players__Buttons__Text'>Tunita</span>
                    </button>
                </div>
            </div>
        </GoalBase>
    );
};

/**
 * ==============================================================================
 * COMPONENTE PRINCIPAL: PICNIC FAN (Controlador del Aficionado)
 * ==============================================================================
 */
const Picnic = () => {
    // --- ESTADOS DE SESIÓN Y RED ---
    const [selectedPlayerId, setSelectedPlayerId] = useState(() => sessionStorage.getItem('picnic.player') || '');
    const [connectionStatus, setConnectionStatus] = useState('idle');
    const [toastMessage, setToastMessage] = useState('');

    // --- ESTADOS DE LA PARTIDA ---
    const [matchDetails, setMatchDetails] = useState({
        matchId: null,
        phase: 'waiting', // waiting | running | finished
        winner: null,
        finalScoreLucho: 0,
        finalScoreTunita: 0,
        gameSettings: null 
    });

    const currentScoreReference = useRef(0);

    // ==========================================================================
    // 1. CONEXIÓN WEB SOCKET
    // ==========================================================================
    useEffect(() => {
        if (!selectedPlayerId) return;

        const handleToast = (msg) => { setToastMessage(msg); setTimeout(() => setToastMessage(''), 2500); };

        // Conecta usando el nuevo BL que tiene auto-reconnect
        ConnectPicnicWebSocket(selectedPlayerId, setConnectionStatus, handleToast).then(() => {
            SetPicnicSocketMessageHandler(processIncomingWebSocketMessage);
        });

        return () => { 
            ClearPicnicSocketMessageHandler(); 
            DisconnectPicnicWebSocket(); 
        };
    }, [selectedPlayerId]);

    // ==========================================================================
    // 2. PROCESAMIENTO DE MENSAJES DEL ADMIN
    // ==========================================================================
    const processIncomingWebSocketMessage = (message) => {
        const messageType = (message?.type || '').toLowerCase();
        const payloadData = message?.data || {};

        switch (messageType) {
            case 'picnic.start':
                let parsedSettings = payloadData.settings;
                if (typeof parsedSettings === 'string') {
                    try { parsedSettings = JSON.parse(parsedSettings); } 
                    catch(e) { console.error("Error leyendo configuraciones del Admin."); }
                }
                
                // case 'picnic.start':
                //     let parsedSettings = null;
                //     try { parsedSettings = JSON.parse(payloadData.settings); } 
                //     catch(e) { console.error("Error leyendo configuraciones del Admin."); }

                currentScoreReference.current = 0; // Reinicio local

                setMatchDetails({
                    matchId: payloadData.matchId,
                    phase: 'running',
                    winner: null,
                    finalScoreLucho: 0,
                    finalScoreTunita: 0,
                    gameSettings: parsedSettings
                });
                break;

            case 'picnic.finished':
                setMatchDetails(prev => ({
                    ...prev,
                    phase: 'finished',
                    winner: payloadData.winner,
                    finalScoreLucho: payloadData.scoreLucho || 0,
                    finalScoreTunita: payloadData.scoreTunita || 0
                }));
                break;

            case 'picnic.layout':
                setMatchDetails(prev => ({ ...prev, phase: 'waiting', matchId: null }));
                break;

            default:
                break;
        }
    };

    // ==========================================================================
    // 3. SINCRONIZACIÓN SILENCIOSA DE PUNTOS EN SEGUNDO PLANO
    // ==========================================================================
    useEffect(() => {
        let backgroundSyncInterval = null;

        if (matchDetails.phase === 'running' && matchDetails.matchId) {
            backgroundSyncInterval = setInterval(() => {
                // Ahora mandamos los datos como un objeto para que empate con el nuevo BL
                SendPicnicScoreProgress({
                    matchId: matchDetails.matchId, 
                    playerId: selectedPlayerId, 
                    currentScore: currentScoreReference.current
                });
            }, 1000); 
        }

        return () => clearInterval(backgroundSyncInterval);
    }, [matchDetails.phase, matchDetails.matchId, selectedPlayerId]);

    // ==========================================================================
    // 4. HANDLER DEL MOTOR DE JUEGO
    // ==========================================================================
    const handleGameScoreChange = (newCalculatedScore) => {
        currentScoreReference.current = newCalculatedScore;
    };

    const handleLocalGameTimeout = (finalLocalScore) => {
        currentScoreReference.current = finalLocalScore;
    };

    // ==========================================================================
    // RENDERIZADO DE PANTALLAS
    // ==========================================================================
    if (!selectedPlayerId) {
        return (
            <>
                {/* <div className='Picnic__Fan__Background'> */}
                    <SelectPicnicPlayer onPlayerPicked={(chosenPlayer) => { 
                        setSelectedPlayerId(chosenPlayer); 
                        sessionStorage.setItem('picnic.player', chosenPlayer); 
                    }} />
                {/* </div> */}
            </>
        )
    }

    return (
        <div className="gfan Picnic__Fan__Background" style={{ position: 'relative', width: '100vw', height: '100dvh', overflow: 'hidden', backgroundColor: '#87ceeb' }}>
            
            {/* Header / StatusBar (Idéntico a Tiro a Gol para consistencia) */}
            <header className="container Fan__Goal__GameHeader position-absolute top-0 w-100 p-3" style={{ zIndex: 100 }}>
                <div className="d-flex flex-column">
                    <img src="/img/page/adsl-five-bicolor.png" className="LogoADSLxZtudia" alt="Logo" style={{ width: '180px' }} />

                    {(matchDetails.phase === 'waiting' || matchDetails.phase === 'finished') && (
                        <div className='d-flex justify-content-between mt-3'>
                            <button type='button' className='Btn__Adsl--RedOutlineTransparent' style={{ width: '100px' }} onClick={() => { setSelectedPlayerId(''); sessionStorage.removeItem('picnic.player'); }}>
                                <i className="bi bi-box-arrow-right"></i> Salir
                            </button>

                            <div className="text-white text-center text-shadow">
                                <p className="mb-0 small font-weight-bold">Jugador: {selectedPlayerId.toUpperCase()}</p>
                                <p className={`mb-0 small text-${connectionStatus === 'connected' ? 'success' : 'warning'}`}>
                                    {connectionStatus === 'connected' ? '🟢 Conectado' : `🔴 ${connectionStatus}`}
                                </p>
                            </div>
                        </div>
                    )}
                </div>
            </header>

            {/* PANTALLA 1: ESPERA (Waiting) */}
            {matchDetails.phase === 'waiting' && (
                <div className="d-flex flex-column h-100 justify-content-center align-items-center text-center p-4 pt-5 mt-4">
                    <img src={selectedPlayerId === 'lucho' ? '/img/games/runtogoal/luchito-caricatura.png' : '/img/games/runtogoal/tunita-caricatura.png'} 
                         alt="Player" className="img-fluid drop-shadow mt-4" style={{ maxHeight: '150px' }} />
                    
                    <h2 className="text-white font-weight-bold mt-1" style={{ fontSize: '2em', textShadow: '2px 2px 4px rgba(0,0,0,0.5)' }}>
                        ¡ELEGISTE A {selectedPlayerId.toUpperCase()}!
                    </h2>
                    
                    <div className="alert alert-light mt-1 shadow-lg" style={{ borderRadius: '20px' }}>
                        <div className="spinner-border spinner-border-sm me-2" role="status"></div>
                        <strong className="fs-5">Esperando a que inicie la partida...</strong>
                    </div>

                    <p className='text-center FooterCredits' style={{ color: '#000' }}>Hecho con ♥ por Interaktia | 2026</p>
                </div>
            )}

            {/* PANTALLA 2: JUEGO EN CURSO (Running) */}
            {/* {matchDetails.phase === 'running' && matchDetails.gameSettings && (
                <div style={{ paddingTop: '60px', height: '100%' }}> {/* Padding top para que el motor de juego no se encime con el header /}
                    <PicnicDayGame 
                        onGameFinishEvent={handleLocalGameTimeout}
                        onCurrentScoreChange={handleGameScoreChange} 
                        gameConfiguration={matchDetails.gameSettings} 
                    />
                </div>
            )} */}
            {/* {matchDetails.phase === 'running' && matchDetails.gameSettings && (
                // NUEVO: Agregamos position relative y zIndex 10 para que pase al frente del background
                <div style={{ position: 'relative', zIndex: 10, paddingTop: '60px', height: '100%' }}> 
                    <PicnicDayGame 
                        onGameFinishEvent={handleLocalGameTimeout}
                        onCurrentScoreChange={handleGameScoreChange} 
                        gameConfiguration={matchDetails.gameSettings} 
                    />
                </div>
            )} */}
            {matchDetails.phase === 'running' && matchDetails.gameSettings && (
                <div style={{ 
                    position: 'absolute', // Absoluto para que ocupe toda la pantalla
                    top: '70px',          // Deja espacio para el Header
                    left: 0, 
                    right: 0, 
                    bottom: 0,            // Hasta abajo de la pantalla
                    zIndex: 50            // Muy importante: 50 lo pone sobre el fondo, pero debajo del Header (100)
                }}> 
                    <PicnicDayGame 
                        onGameFinishEvent={handleLocalGameTimeout}
                        onCurrentScoreChange={handleGameScoreChange} 
                        gameConfiguration={matchDetails.gameSettings} 
                    />
                </div>
            )}

            {/* PANTALLA 3: RESULTADOS (Finished) */}
            {matchDetails.phase === 'finished' && (
                <div className="d-flex flex-column h-100 justify-content-start align-items-center text-center p-4 pt-5" style={{ backgroundColor: 'rgba(255,255,255,0.95)', zIndex: 1000, position: 'absolute', inset: 0 }}>
                    <img src="/img/page/adsl-five-bicolor.png" className="LogoADSLxZtudia m-0 mb-4" alt="Logo" />
                    <h1 className="font-weight-bold text-dark mb-1 mt-2" style={{ fontSize: '1em' }}>¡TIEMPO AGOTADO!</h1>
                    
                    <div className="my-4">
                        {matchDetails.winner === 'tie' ? (
                            <h2 className="text-primary font-weight-bold" style={{ fontSize: '2em' }}>¡ES UN EMPATE!</h2>
                        ) : matchDetails.winner === selectedPlayerId ? (
                            <h2 className="text-success font-weight-bold" style={{ fontSize: '2em' }}>¡GANASTE! 🎉</h2>
                        ) : (
                            <h2 className="text-danger font-weight-bold" style={{ fontSize: '2em' }}>¡PERDISTE! 😢</h2>
                        )}
                    </div>

                    <div className="card border-0 w-100 mb-5" style={{ borderRadius: '20px', maxWidth: '400px' }}>
                        <div className="card-body">
                            <h5 className="text-muted font-weight-bold border-bottom pb-2">Marcador final</h5>
                            <div className="d-flex justify-content-between fs-3 mt-3 px-3">
                                <span><strong style={{ color: selectedPlayerId === 'lucho' ? '#0d6efd' : '#6c757d' }}>Lucho:</strong> {matchDetails.finalScoreLucho}</span>
                                <span><strong style={{ color: selectedPlayerId === 'tunita' ? '#0d6efd' : '#6c757d' }}>Tunita:</strong> {matchDetails.finalScoreTunita}</span>
                            </div>
                        </div>
                    </div>

                    {/* <img src={imgBrand} alt="Patrocinador" className='img-fluid drop-shadow mt-auto mb-3' style={{ maxWidth: '200px' }} /> */}
                    {/* <button className="btn btn-outline-secondary w-75 rounded-pill font-weight-bold mb-3" onClick={() => window.location.reload()}>
                        Salir al menú
                    </button> */}

                    <p className='text-center FooterCredits' style={{ zIndex: '110', color: '#000' }}>Hecho con ♥ por Interaktia | 2026</p>
                </div>
            )}

            {toastMessage && (
                <div className="position-absolute bottom-0 start-50 translate-middle-x mb-4 bg-dark text-white px-4 py-2 rounded-pill shadow" style={{ zIndex: 9999 }}>
                    {toastMessage}
                </div>
            )}
        </div>
    );
};

export { Picnic };